var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ai-chat-widget",
      class: { "ai-chat-widget--expanded": _vm.expanded },
      attrs: {
        "data-testid": "ai-chat-widget",
        "data-session-id": _vm.sessionId,
      },
    },
    [
      _c(
        "v-tooltip",
        {
          attrs: { top: "", disabled: !_vm.disabledButton },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function (ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "div",
                    _vm._g(
                      _vm._b(
                        {
                          staticClass: "d-inline-block",
                          attrs: {
                            "data-testid":
                              "ai-chat-minimized-tooltip-activator",
                          },
                        },
                        "div",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c("round-button", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.expanded && !_vm.isAnimating,
                            expression: "!expanded && !isAnimating",
                          },
                        ],
                        ref: "minimizedButton",
                        staticClass: "ai-chat-widget__minimized",
                        attrs: {
                          icon: "mdi-robot",
                          disabled: _vm.disabledButton,
                          elevation: 2,
                          "data-testid": "ai-chat-minimized-button",
                        },
                        on: { click: _vm.expand },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "span",
            { attrs: { "data-testid": "ai-chat-minimized-tooltip" } },
            [_vm._v(_vm._s(_vm.tooltipText))]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: { name: "slide-up" },
          on: {
            "before-leave": _vm.handleBeforeLeave,
            "after-leave": _vm.handleAfterLeave,
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.expanded,
                  expression: "expanded",
                },
              ],
              staticClass: "ai-chat-widget__window",
              attrs: { "data-testid": "ai-chat-window" },
            },
            [
              _c("div", { staticClass: "ai-chat-widget__header" }, [
                _c(
                  "span",
                  {
                    staticClass: "ai-chat-widget__title",
                    attrs: { "data-testid": "ai-chat-title" },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.chatTitle) +
                        " (" +
                        _vm._s(_vm.selectionStatus) +
                        ")"
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ai-chat-widget__controls" },
                  [
                    _c(
                      "v-btn",
                      {
                        ref: "newSessionButton",
                        attrs: {
                          icon: "",
                          small: "",
                          title: _vm.$t("new_session"),
                          "data-testid": "ai-chat-new-session-button",
                        },
                        on: { click: _vm.newSession },
                      },
                      [
                        _c("v-icon", { attrs: { small: "" } }, [
                          _vm._v("mdi-refresh"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        ref: "minimizeButton",
                        attrs: {
                          icon: "",
                          small: "",
                          title: _vm.$t("minimize"),
                          "data-testid": "ai-chat-minimize-button",
                        },
                        on: { click: _vm.minimize },
                      },
                      [
                        _c("v-icon", { attrs: { small: "" } }, [
                          _vm._v("mdi-window-minimize"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { ref: "history", staticClass: "ai-chat-widget__history" },
                [
                  _vm._l(_vm.messages, function (msg) {
                    return _c(
                      "div",
                      {
                        key: msg.timestamp,
                        class: "ai-chat-widget__" + msg.type,
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "ai-chat-widget__message",
                            attrs: {
                              "data-testid": _vm.getMessageTestId(msg.type),
                            },
                          },
                          [_vm._v(_vm._s(msg.text))]
                        ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.waitingForResponse
                    ? _c("div", { class: "ai-chat-widget__response" }, [
                        _c(
                          "div",
                          { staticClass: "ai-chat-widget__message" },
                          [
                            _c("v-progress-circular", {
                              attrs: {
                                color: "primary",
                                indeterminate: "",
                                size: "20",
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shouldShowPresets
                    ? _c(
                        "div",
                        {
                          staticClass: "ai-chat-widget__presets",
                          attrs: { "data-testid": "ai-chat-presets" },
                        },
                        _vm._l(_vm.$t("presets"), function (preset) {
                          return _c(
                            "v-chip",
                            {
                              key: preset,
                              staticClass: "mx-1 mb-1",
                              attrs: {
                                small: "",
                                disabled: !_vm.canSendMessage,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.sendMessage(preset)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(preset) +
                                  "\n          "
                              ),
                            ]
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "ai-chat-widget__footer" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputValue,
                      expression: "inputValue",
                    },
                  ],
                  ref: "aiChatInput",
                  staticClass: "ai-chat-widget__input",
                  attrs: {
                    placeholder: _vm.inputPlaceholder,
                    disabled: !_vm.canInputMessage,
                    rows: "1",
                    "data-testid": "ai-chat-input",
                  },
                  domProps: { value: _vm.inputValue },
                  on: {
                    keydown: _vm.handleTextarea,
                    compositionstart: function ($event) {
                      _vm.composing = true
                    },
                    compositionend: function ($event) {
                      _vm.composing = false
                    },
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.inputValue = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "ai-chat-widget__disclaimer" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("disclaimer")) + "\n        "
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }